import { ElLoading } from 'element-plus'
import { reqDownRecord } from '@/api/modules/file'
import api from '@/api/index'
/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {object} source
 * @returns {object}
 */
export function deepClone(source: any) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach((keys) => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    }
    else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    }
    else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) { context = args = null }
      }
    }
  }

  return function (...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) { timeout = setTimeout(later, wait) }
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/*
 * 输入正数
 * @param {number} valNum
 * @param {boolean} toFixed 保留两位小数标识
 * @param {number} decimal
*/
export function clearNoNum(valNum, toFixed = true, decimalPlaces = 2) {
  valNum = valNum.toString()
  valNum = valNum.replace(/[^\d.]/g, '') // 清除"数字"和"."以外的字符
  valNum = valNum.replace(/^\./g, '') // 验证第一个字符是数字
  if (toFixed) { // 需要保留两位小数标识
    valNum = valNum.replace(/\.{2,}/g, '.') // 只保留第一个, 清除多余的
    valNum = valNum.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
    valNum = valNum.replace(decimalPlaces === 2 ? /^(-)*(\d+)\.(\d\d).*$/ : /^(-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3') // 只能输入两个小数
    if (!valNum.includes('.') && valNum !== '') { // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的数字
      valNum = Number.parseFloat(valNum)
    }
  }
  else { // 返回整数
    valNum = valNum ? Number.parseInt(valNum) : ''
  }
  return valNum
}

/**
 * Merges two objects, giving the last one precedence
 * @param {object} target
 * @param {(object | Array)} source
 * @returns {object}
 */
export function objectMerge(target, source) {
  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach((property) => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    }
    else {
      target[property] = sourceProperty
    }
  })
  return target
}

/* 下载public文件夹的静态资源
* * @param {string} fileLink 文件路径
 * @param {string} fileName 文件名称
 * */
export function downLoadLocalFile(fileLink: any, fileName?: string) {
  const link = document.createElement('a')
  link.href = fileLink

  // 从URL中提取文件名
  link.download = fileName || 'downloaded'

  // 触发下载
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

/* 上传文件公共参数
*  * @returns {object}
* */
export function uploadParams() {
  return {
    'x-token': '',
  }
}

/**
 * 导出后端返回的文件流
 *  @param {string} res 后端返回文件流res
 *  @param {string} fileName 自定义文件名
 *  @param {number} downloadType 下载文件的文件类型
 * .xls====>application/vnd.ms-excel
 * .xlsx====>application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
 * .txt====>text/plain
 * .png/.jpg/.gif====>image/*
 * .avi/ .mpg/ .mpeg/ .mp4  ====>video/*
 * .mp3/ .wav/  ====>audio/*
 * .pdf  ====>application/pdf
 */
export function exportFileStream(res, fileName, downloadType = 0) {
  // if (!downloadType) { // 没有设置类型时
  //   alert('请传入文件类型索引值')
  //   return false
  // }
  const fileTypeList = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/plain', 'image/*', 'video/*', 'audio/*', 'application/pdf', 'application/zip']
  const blob = new Blob([res], {
    type: fileTypeList[downloadType], // 将会被放入到blob中的数组内容的MIME类型
  })
  const objectUrl = URL.createObjectURL(blob) // 生成一个url
  const a = document.createElement('a')
  a.href = objectUrl
  a.download = fileName
  a.click()
}

export async function downloadFile(data: any) {
  if (data.id) {
    // 记录下载
    await reqDownRecord({ knowledge_files: [{ id: data.id }] })
  }
  const downloadLoadingInstance = ElLoading.service({ text: '正在下载数据，请稍候', background: 'rgba(0, 0, 0, 0.7)' })
  try {
    const url = data.file_detail.file
    const fileName = data.name
    const res = await api.post('/common/download/file', { url }, { responseType: 'blob' })
    const blob = new Blob([res.data])
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = fileName
    link.click()
  }
  catch (error) {
    console.log(error, 'downloadFile')
  }
  finally {
    downloadLoadingInstance.close()
  }
}

// 自定义导出
export function exportFile(res: any) {
  const contentDisposition = res.headers['content-disposition']
  let fileName = ''
  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
    if (fileNameMatch && fileNameMatch[1]) {
      fileName = fileNameMatch[1].replace(/['"]/g, '')
    }
  }
  const blob = new Blob([res.data], {
    type: res.data.type, // 将会被放入到blob中的数组内容的MIME类型
  })
  const objectUrl = URL.createObjectURL(blob) // 生成一个url
  const a = document.createElement('a')
  a.href = objectUrl
  a.download = fileName
  a.click()
}

export function checkMobile() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  // 常见的移动设备关键词
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
  return mobileRegex.test(userAgent)
}
